import { Box, CircularProgress, LinearProgress } from '@mui/material'
import React, { useEffect } from 'react'
import { makeStyles, withStyles } from '@mui/styles';
import { getSetting } from '../assets/redux/SettingRedux';
import { useSelector } from 'react-redux';
const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 4,
        borderRadius: 10,
        position: 'relative',
        top: '70px',
        width: '70px',
    },

}))(CircularProgress);

const useStyles = makeStyles({
    root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundRepeat: 'no-repeat !important',
        backgroundSize: 'cover !important'
    },
    container: {
        position: 'absolute',
        maxWidth: '200px',
        height: 'auto',
        bottom: '15%',
        transform: 'translate(-50%,-60%)',
        left: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },

});

export default function Splash(props: any) {
    const setting = useSelector((state: any) => getSetting(state.SettingRedux));
    const classes = useStyles();
    return (
        <Box className={classes.root} style={{ background: `url('${setting.logoSplashApp}')`}}>
            <Box className={classes.container}>
                <BorderLinearProgress />

            </Box>
        </Box>
    )

}